import React from 'react';
import T from 'prop-types';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';

import { Container, Layout } from './style';

interface MainProps {
  children: React.ReactNode;
}

const Main: React.FC<MainProps> = ({ children }) => (
  <>
    <Navbar />
    <Layout>
      <Layout.Content>
        <Container>{children}</Container>
      </Layout.Content>
      <Footer />
    </Layout>
  </>
);

Main.propTypes = {
  children: T.node.isRequired,
};

export default Main;
